// @module ContactUs
define(
	'ContactUs'
,	[
		'ContactUs.Router'
	]
,	function (
		ContactUsRouter
	)
{
	'use strict';

	//@class ContactUs @extends ApplicationModule
	return {
		mountToApp: function (application)
		{
			return new ContactUsRouter(application);
		}
	};
});
